export class ConciliacionRequestBHE {
   emisorId: string;
   usuarioId: string;
   fecha: string;
}
